require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
	'flickity',
	'root/Assets/Js/Vendor/in-view',
	'root/Base/Js/MbiBrowser',
	'root/Base/Js/Vendor/PictureFill',
	'root/Base/Js/Vendor/LazySizes',
	'root/Assets/Js/Vendor/LazySizesRespImg',
	'root/Assets/Js/Templates',
	'root/Base/Js/Vendor/Modernizr'
], function(
	$,
	mbiImageSize,
	mbiMq,
	Flickity,
	inView
	) {

	'use strict';

	mbiImageSize.init();

	$(window).load(function(){
		$('body').addClass('is_loaded');
	});


	if ($('.newsletter-form').length) {
		$('input[type=text], input[type=email]').on('change', function () {
			var $label = $(this).siblings('label');
			var value = $(this).val();
			if (value) {
				$label.addClass('hidden');
			} else {
				$label.removeClass('hidden');
			}
		});
	}

	$('.js_scroll-down').click(function(e) {
		var offset = $(this).offset();
		$('body, html').animate({
			scrollTop: offset.top
		}, 600, 'swing' );
	});

	if ($('body').hasClass('single-post')) {
		$('.post-links .link').each(function() {
			var $children = $(this).children();
			// console.log($children);
			if ($children.length === 1) {
				$children.first().css('display', 'none');
			}
		});
	}

	$(document).on('submit', '#mc-embedded-subscribe-form', function(e){

		e.preventDefault();
		e.stopPropagation();

		var $form = $(this);
		var valid = $form[0].checkValidity();

		if (valid) {
			$.ajax({
		        type: $form.attr('method'),
		        url: $form.attr('action'),
		        data: $form.serialize(),
		        dataType    : 'jsonp',
		        contentType: "application/json",
		        success: function(response) {

		        	// console.log('success');
		        	// console.log(response.result);

		        	$('.newsletter-thank-you').removeAttr('aria-hidden');
		        	$('.newsletter-text, .newsletter-form').attr('aria-hidden', true);

				},
				error: function(response) {

					$('.newsletter-thank-you').removeAttr('aria-hidden');
					$('.newsletter-text, .newsletter-form').attr('aria-hidden', true);

					// console.log($form.attr('method'));
					// console.log($form.attr('action'));
					// console.log($form.serialize());
					// console.log(response);

				}
	 		});
		}
	});


	/* News slider */

	function createFlickity() {
        if ($('.news-slider').length>0) {
            $('.news-slider').each(function(index, el) {
                if (el) {
    	            var flkty = new Flickity( el, {
    	                cellSelector: '.js_flickity_slide',
                        pageDots: false,
    	                wrapAround: true,
    	                prevNextButtons: false
    	            });

    	            // previous
    	            $('.button--prev').on( 'click', function() {
    	              flkty.previous();
    	            });
    	            // next
    	            $('.button--next').on( 'click', function() {
    	              flkty.next();
    	            });

            	}
            });

        }
    }


    if ($('.news-slider').length) {
        //mbiImageSize.init();
        setTimeout(function(){
            createFlickity();
        }, 100);
    }
    $(document).on('recreateSlides', function(){
       if ($('.news-slider').length) {
            createFlickity();
        }

    });

    var browserV = $('html').data('browser-version');
    // console.log(browserV);
    // var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
    // alert(isIE11)
    if (browserV == 'IE 11') {
		alert('Sie verwenden einen Outdated Browser, dadurch kann es zu Darstellungsproblemen auf der Seite kommen. Bitte Updaten Sie Ihren Browser.');
    }
    // var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
    // alert(isIE11);

});
define("Assets/Js/Footer.js", function(){});

